define([
	"./_List",
	"./PluginFactory"
], function(_List,PluginFactory) {

	return PluginFactory.declare(_List, {
		"class": "csi-button-toggle csi-single-toggle",
		orderType: "ol",
		materialIcon: "format_list_numbered",
		pluginName: "orderList",
		title: "CanvasOrderList"
	});
});
